export default function TransferIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5195 7.84159L13.9995 5.36157L11.5195 2.88159" stroke="#616161" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M2 5.36157H14" stroke="#616161" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.47998 9.9082L2 12.3882L4.47998 14.8682" stroke="#616161" strokeLinecap="round"
            strokeLinejoin="round"/>
      <path d="M14 12.3882H2" stroke="#616161" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
